import { Type } from "class-transformer";
import { Changerequest } from "./changerequest-model";
import { Duty } from "./duties";
import { Employment } from "./employments";
import { AbstractJSONModel } from "./master-model";

export interface IWebAcceptPages {
  change_requests: Changerequest[];
  duties: Duty[];
  bell_times: any[];
  employments: Employment[];
}

export class WebAcceptPages extends AbstractJSONModel implements IWebAcceptPages {
  @Type(() => Changerequest)
  change_requests: Changerequest[] = [];
  @Type(() => Duty)
  duties: Duty[] = [];
  bell_times: any[] = [];
  @Type(() => Employment)
  employments: Employment[] = [];
}
